import React, { useState } from 'react';
import { Button, Popconfirm, Modal, Typography, Form } from '@douyinfe/semi-ui';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import FieldRuleForm from './index';

/**
 * 多字段可视化编辑组件
 * @param {Array} value 字段数组 [{ n, r, t, d, p, l, u }]
 * @param {Function} onChange 变更回调
 */
const MultiFieldRuleForm = ({ value = [], onChange }) => {
    const [fields, setFields] = useState(value.length ? value : [{ n: '', r: false, t: '', d: '', p: '', l: '', u: false }]);
    const [editIdx, setEditIdx] = useState(null);
    const [modalVisible, setModalVisible] = useState(false);
    const [editField, setEditField] = useState(null);
    const [formApi, setFormApi] = useState(null);

    // 同步外部变更
    React.useEffect(() => {
        setFields(value && value.length ? value : [{ n: '', r: false, t: '', d: '', p: '', l: '', u: false }]);
    }, [value]);

    // 拖拽排序
    const handleDragEnd = (result) => {
        if (!result.destination) return;
        const newFields = Array.from(fields);
        const [removed] = newFields.splice(result.source.index, 1);
        newFields.splice(result.destination.index, 0, removed);
        setFields(newFields);
        onChange && onChange(newFields);
    };

    // 删除
    const handleRemove = (idx) => {
        const newFields = fields.filter((_, i) => i !== idx);
        setFields(newFields);
        onChange && onChange(newFields);
    };

    // 新增
    const handleAdd = () => {
        setEditIdx(fields.length);
        setEditField({ n: '', r: false, t: '', d: '', p: '', l: '', u: false });
        setModalVisible(true);
    };

    // 编辑
    const openEdit = (idx) => {
        setEditIdx(idx);
        setEditField(fields[idx]);
        setModalVisible(true);
    };

    return (
        <div>
            <DragDropContext onDragEnd={handleDragEnd}>
                <Droppable droppableId="fields-droppable">
                    {(provided) => (
                        <div ref={provided.innerRef} {...provided.droppableProps}>
                            {fields.map((field, idx) => (
                                <Draggable key={idx} draggableId={String(idx)} index={idx}>
                                    {(provided) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                marginBottom: 8,
                                                background: '#f5f6fa',
                                                borderRadius: 4,
                                                padding: '8px 12px',
                                                ...provided.draggableProps.style
                                            }}
                                        >
                                            <span {...provided.dragHandleProps} style={{ cursor: 'grab', marginRight: 8 }}>≡</span>
                                            <Typography.Text style={{ flex: 1, cursor: 'pointer' }} onClick={() => openEdit(idx)}>
                                                {field.n || `字段${idx + 1}`}
                                            </Typography.Text>
                                            <Popconfirm title="确定删除该字段？" onConfirm={() => handleRemove(idx)}>
                                                <Button type="danger" size="small">删除</Button>
                                            </Popconfirm>
                                        </div>
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
            <Button type="primary" onClick={handleAdd} block style={{ marginTop: 12 }}>新增字段</Button>
            <Modal
                title={editIdx === fields.length ? '新增字段' : '编辑字段'}
                visible={modalVisible}
                onCancel={() => setModalVisible(false)}
                onOk={() => formApi && formApi.submitForm()}
                width={480}
                centered
                bodyStyle={{ paddingTop: 24 }}
            >
                <Form
                    initValues={editField}
                    getFormApi={setFormApi}
                    onSubmit={val => {
                        let newFields = [...fields];
                        if (editIdx === fields.length) {
                            newFields.push({ ...val });
                        } else {
                            newFields[editIdx] = { ...val };
                        }
                        setFields(newFields);
                        onChange && onChange(newFields);
                        setModalVisible(false);
                    }}
                >
                    <FieldRuleForm fieldPrefix="" typeValue={editField?.t} />
                </Form>
            </Modal>
        </div>
    );
};

export default MultiFieldRuleForm; 